<script lang="ts">
    import { getContainer } from '$components/Context/ContainerContext';
    import { getSecuredAreaActions } from '$components/Context/SecuredAreaModalContext';

    let actions = getSecuredAreaActions();
    let user = getContainer().currentUserStore().currentUser();
    $: isLogged = $user != null;
</script>

{#if isLogged}
    <slot {isLogged} />
{:else}
    <div
        role="button"
        tabindex="-1"
        on:keypress|preventDefault={(e) => {
            if (e.key === 'Enter') actions.open();
        }}
        on:click={actions.open}
    >
        <div class="pointer-events-none">
            <slot {isLogged} />
        </div>
    </div>
{/if}
